import { memo, useCallback } from 'react';
import { View, StyleSheet, Text, Image } from 'react-native';
import { Container } from '../components';
import { COLOR, FONT, __WEB__, THEME } from '../../constants/styles';

import { useDispatch, useSelector } from 'react-redux';

import { getCurrentEmployer, getAssociatedEmployer } from '../../selectors/employers';

import SidebarMilStaff from './sidebar_mil_staff';
import SidebarMilPatient from './sidebar_mil_patient';
import SidebarConsumer from './sidebar_consumer';
import SidebarMedRecruiterStaff from './sidebar_med_recruiter_staff';
import SidebarMedRecruiterPatient from './sidebar_med_recruiter_patient';

import { EMPLOYER_TYPE_AIRFORCE, EMPLOYER_TYPE_MED_RECRUITER } from '../../constants/employerTypes';

export default memo(function SideNav(props) {
  const associatedEmployer = useSelector(getAssociatedEmployer);
  const employer = useSelector(getCurrentEmployer);

  const isAirforceStaff = employer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  const isAirforcePatient =
    !isAirforceStaff && associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  const isMedRecruiterStaff = employer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER;
  const isMedRecruiterPatient =
    !isMedRecruiterStaff && associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER;
  // const isMedRecruiterStaff = false;
  // const isMedRecruiterPatient = true;

  const isConsumer = !associatedEmployer;

  function renderContents() {
    if (isAirforceStaff) {
      return <SidebarMilStaff {...props} />;
    } else if (isAirforcePatient) {
      return <SidebarMilPatient {...props} />;
    } else if (isMedRecruiterStaff) {
      return <SidebarMedRecruiterStaff {...props} />;
    } else if (isMedRecruiterPatient) {
      return <SidebarMedRecruiterPatient {...props} />;
    }

    return <SidebarConsumer {...props} />;
  }
  return (
    <View style={[styles.container, isConsumer ? styles.containerConsumer : null]}>
      <View style={[styles.header, isConsumer ? styles.headerConsumer : null]}>
        <Image style={styles.brandingImage} source={require('../../../resources/icon.png')} />
        <Text style={[styles.brandingText, isConsumer ? styles.brandingTextConsumer : null]}>
          OUTPATIENT APP
        </Text>
      </View>
      <Container scrollView={!__WEB__} style={{ flex: 1 }}>
        <View style={styles.contents}>{renderContents()}</View>
      </Container>
    </View>
  );
});

const styles = StyleSheet.create({
  container: __WEB__
    ? {
        flex: 1,
        backgroundColor: COLOR.labelText,
        overflow: 'auto',
      }
    : {
        flex: 1,
        backgroundColor: COLOR.labelText,
        paddingTop: 60,
      },
  containerConsumer: {
    backgroundColor: COLOR.altContrast,
    borderRightWidth: 1,
    borderRightColor: COLOR.accent,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 80,
    paddingHorizontal: 20,
    backgroundColor: COLOR.labelText,
  },
  headerConsumer: {
    height: 60,
  },
  brandingImage: {
    width: 42,
    height: 42,
  },
  brandingText: {
    ...FONT.medium,
    fontSize: __WEB__ ? 12 : 14,
    color: 'white',
    marginLeft: 14,
    letterSpacing: 2,
  },
  brandingTextConsumer: {
    // color: 'black',
  },
  contents: {
    paddingBottom: 30,
  },
});
